import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { session } from './lib/api';
import { startAutoFlush } from './lib/outbox';
import Login from './screens/Login';
import PayReturn from './screens/PayReturn';
import Till from './screens/Till';
import Returns from './screens/Returns';
import Shift from './screens/Shift';
import AdminLayout from './screens/admin/AdminLayout';
import Dashboard from './screens/admin/Dashboard';
import Products from './screens/admin/Products';
import StockAdjust from './screens/admin/StockAdjust';
import Staff from './screens/admin/Staff';
import Terminals from './screens/admin/Terminals';
import DataQuality from './screens/admin/DataQuality';
import Exceptions from './screens/admin/Exceptions';
import ImportExport from './screens/admin/ImportExport';
import Shell from './components/Shell';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } },
});

function Protected({ children }: { children: React.ReactNode }) {
  return session.get() ? <>{children}</> : <Navigate to="/login" replace />;
}

startAutoFlush();

// Matches Vite's `base` so routing works when mounted at e.g. /pos/
const basename = (import.meta as any).env?.BASE_URL ?? '/';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pay/return" element={<PayReturn />} />
          <Route element={<Protected><Shell /></Protected>}>
            <Route path="/" element={<Till />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/shift" element={<Shift />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="products" element={<Products />} />
              <Route path="stock" element={<StockAdjust />} />
              <Route path="import" element={<ImportExport />} />
              <Route path="staff" element={<Staff />} />
              <Route path="terminals" element={<Terminals />} />
              <Route path="data-quality" element={<DataQuality />} />
              <Route path="exceptions" element={<Exceptions />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
